import React from 'react';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import MyGallery from "../Gallery/MyGallery";
import './RecentProjects.css'

function RecentProjects() {
    const { t } = useTranslation();
    const directory= "/images/recent/";
    const filenames=[
        'VPR02340_Vasso_Paraschi.webp',
        'VPR02452_Vasso_Paraschi.webp',
        'VPR02476_Vasso_Paraschi.webp',
        'VPR02526_Vasso_Paraschi.webp',
        'VPR02571_Vasso_Paraschi.webp',
        'VPR02604_Vasso_Paraschi.webp',
        'VPR02662_Vasso_Paraschi.webp',
        'VPR02672_Vasso_Paraschi.webp',
        'VPR02735_Vasso_Paraschi.webp',
        'VPR02835_Vasso_Paraschi.webp',
        'VPR02837-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR02846-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR02849_Vasso_Paraschi.webp',
        'VPR02855-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR02872_Vasso_Paraschi.webp',
        'VPR02997_Vasso_Paraschi.webp',
        'VPR03000_Vasso_Paraschi.webp',
        'VPR03031_Vasso_Paraschi.webp',
        'VPR03040_Vasso_Paraschi.webp',
        'VPR03062_Vasso_Paraschi.webp',
        'VPR03128-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03195_Vasso_Paraschi.webp',
        'VPR03226_Vasso_Paraschi.webp',
        'VPR03307_Vasso_Paraschi.webp',
        'VPR03372_Vasso_Paraschi.webp',
        'VPR03431_Vasso_Paraschi.webp',
        'VPR03447_Vasso_Paraschi.webp',
        'VPR03488-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03554_Vasso_Paraschi.webp',
        'VPR03559-Enhanced-NR_Vasso_Paraschi.webp'
    ];
    return (
        <div className="recent-projects-section">
            <h1>Recent Projects</h1>
            <div className="recent-projects-photo-container">
                <MyGallery directory={directory} filenames={filenames} isForRecentProjects />
            </div>
        </div>
    );
}

export default RecentProjects;
